<template>
    <div class="toast-container">
        <transition-group name="toast">
            <div
                v-for="toast in toasts"
                :key="toast.id"
                :class="['toast', `toast-${toast.type}`]"
                @click="remove(toast.id)"
            >
                <vue-feather
                    :type="iconType(toast.type)"
                    size="18"
                    class="toast-icon"
                />
                <span class="toast-message">{{ toast.message }}</span>
                <vue-feather type="x" size="14" class="toast-close" />
            </div>
        </transition-group>
    </div>
</template>

<script>
import { useToast } from '../composables/useToast'

export default {
    name: 'ToastContainer',
    setup() {
        const toast = useToast()
        return { toasts: toast.toasts, remove: toast.removeToast }
    },
    methods: {
        iconType(type) {
            switch (type) {
                case 'error': return 'alert-circle'
                case 'success': return 'check-circle'
                case 'info': return 'info'
                default: return 'info'
            }
        }
    }
}
</script>

<style scoped>
.toast-container {
    position: fixed;
    top: 24px;
    right: 24px;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    gap: 10px;
    pointer-events: none;
}

.toast {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 16px;
    border-radius: 12px;
    background-color: var(--bg-card);
    color: var(--text-primary);
    border: 1px solid var(--border-color);
    box-shadow: 0 4px 16px var(--shadow-dropdown);
    min-width: 280px;
    max-width: 420px;
    cursor: pointer;
    pointer-events: auto;
    font-size: 14px;
    line-height: 1.4;
}

.toast-error {
    border-left: 4px solid var(--accent-danger);
}

.toast-error .toast-icon {
    color: var(--accent-danger);
}

.toast-success {
    border-left: 4px solid #4caf50;
}

.toast-success .toast-icon {
    color: #4caf50;
}

.toast-info {
    border-left: 4px solid #2196f3;
}

.toast-info .toast-icon {
    color: #2196f3;
}

.toast-icon {
    flex-shrink: 0;
}

.toast-message {
    flex: 1;
}

.toast-close {
    flex-shrink: 0;
    color: var(--text-muted);
    opacity: 0.6;
}

.toast:hover .toast-close {
    opacity: 1;
}

/* Transitions */
.toast-enter-active {
    transition: all 0.3s ease;
}

.toast-leave-active {
    transition: all 0.25s ease;
}

.toast-enter-from {
    opacity: 0;
    transform: translateY(-20px);
}

.toast-leave-to {
    opacity: 0;
    transform: translateY(-20px);
}

.toast-move {
    transition: transform 0.3s ease;
}

@media (max-width: 480px) {
    .toast-container {
        top: 16px;
        right: 16px;
        left: 16px;
    }

    .toast {
        min-width: auto;
        max-width: none;
    }
}
</style>
